// 개인정보 고지 문안 정본 — 개인정보처리방침(/privacy)과 회원가입 동의 칸이 같은 문장을 쓴다.
// 문안을 바꾸면 두 화면이 함께 바뀌고, 가입 동의 기록(signup_terms)에도 이 문장이 그대로 남는다. (대표 확정 2026-10-27)

export const PRIVACY_POLICY_EFFECTIVE_DATE = '2026년 10월 27일';

export interface NoticeRow {
    label: string;
    value: string;
}

/** 개인정보 수집·이용 고지(개인정보 보호법 제15조 제2항) */
export const COLLECTION_NOTICE: NoticeRow[] = [
    {
        label: '수집 항목',
        value: '휴대전화번호, Instagram 계정 정보(아이디·공개 프로필), 분석 요청 및 이용 내역, 크레딧 충전·사용 내역, 입금자명, 환불 계좌 정보(은행명·계좌번호·예금주), 고객 문의 내용, 접속 IP 주소·기기 및 브라우저 정보·접속 일시 등 서비스 이용 기록',
    },
    {
        label: '이용 목적',
        value: '회원 식별 및 가입·탈퇴 관리, 분석 서비스 제공 및 결과 발송(문자·알림톡·웹 푸시), 크레딧 충전 확인·환불 처리 및 정산, 고객 문의 응대 및 분쟁 처리, 부정 이용 방지, 서비스 품질 개선 및 이용 통계 분석, 광고성 정보(이벤트·혜택·신규 서비스) 안내',
    },
    {
        label: '보유·이용 기간',
        value: '회원 탈퇴 시까지 보유하며, 탈퇴가 완료되면 지체 없이 파기합니다. 다만 관계 법령에 따라 보존할 필요가 있는 정보는 해당 법정 기간 동안 보관합니다.',
    },
    {
        label: '동의 거부 권리',
        value: '동의를 거부할 권리가 있으며, 위 항목은 서비스 제공에 반드시 필요한 정보이므로 거부하시면 회원가입이 제한됩니다.',
    },
];

/** VIP 검색자 알림을 위한 개인정보 제3자 제공 고지(개인정보 보호법 제17조 제2항) */
export const VIP_THIRD_PARTY_NOTICE: NoticeRow[] = [
    {
        label: '제공받는 자',
        value: '회원이 분석을 요청한 Instagram 계정의 소유자로서 소셜데이터랩 VIP 플랜을 이용 중인 회원',
    },
    {
        label: '제공 목적',
        value: 'VIP 플랜의 검색자 알림 서비스 제공(자신의 계정을 분석한 이용자 확인)',
    },
    {
        label: '제공 항목',
        value: 'Instagram 아이디, 휴대전화번호, 분석 요청 일시, 분석 결과 수령 여부',
    },
    {
        label: '보유·이용 기간',
        value: '제공받는 회원의 VIP 서비스 이용 기간(해당 회원의 탈퇴 시까지)',
    },
    {
        label: '동의 거부 권리',
        value: '동의를 거부할 권리가 있으며, 검색자 알림은 소셜데이터랩 서비스의 필수 구성 요소이므로 거부하시면 회원가입이 제한됩니다.',
    },
];

/** 법정 보존 기간 */
export const LEGAL_RETENTION: string[] = [
    '계약 또는 청약철회 등에 관한 기록(서비스 이용 동의 기록 포함): 5년 (전자상거래 등에서의 소비자보호에 관한 법률)',
    '대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)',
    '소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래 등에서의 소비자보호에 관한 법률)',
    '표시·광고에 관한 기록: 6개월 (전자상거래 등에서의 소비자보호에 관한 법률)',
    '웹사이트 방문 기록(접속 로그·접속 IP): 3개월 (통신비밀보호법)',
];

/** 개인정보 처리 위탁(개인정보 보호법 제26조 제2항) */
export const PROCESSING_VENDORS: string[] = [
    'Supabase Inc. — 데이터베이스·회원 인증 등 서비스 인프라 운영',
    'Netlify, Inc. — 웹사이트 호스팅',
    '솔라피(SOLAPI) — 문자메시지·카카오 알림톡 발송',
    '알리고(ALIGO) — 문자메시지 발송',
    '팝빌(POPBILL) — 무통장 입금 내역 확인',
    'Resend — 이메일 발송',
    'Apify — 공개된 Instagram 데이터의 수집 처리',
    'ImageKit — 프로필 이미지 저장 및 전송',
    'Google LLC — Google Analytics 이용 통계 분석, Google Ads 광고 성과 측정(SHA-256 해시값만 전송)',
    'Microsoft Corporation — Microsoft Clarity 이용 행태 분석',
];

/** 가입 동의 기록에 남길 고지 원문 한 덩어리 */
export function noticeAsText(rows: NoticeRow[]): string {
    return rows.map((r) => `${r.label}: ${r.value}`).join(' / ');
}
